
import md5 from 'js-md5'
import VueCookie from 'vue-cookie'
const commonEventJs = {
    GetApiUrl(original) {
        return apiEndpoints.paths[original]
    },
    parseCookieValue(cookieValue) {
        if (!cookieValue) return {};

        try {
            return JSON.parse(cookieValue);
        } catch (error) {
            console.warn('Invalid cookie JSON:', error);
            return {};
        }
    },
    GetUserInfo() {
        return this.parseCookieValue(VueCookie.get('cardUser'));
    },
    GetAccountInfo() {
        const UserDetail = this.parseCookieValue(VueCookie.get('Card_Seller_USERDTL'));
        return UserDetail && UserDetail.AccountId ? UserDetail.AccountId : null;
    },
    FormToAuth(form, options = {}) {
        /*
            使用示例 
            //保留所有字段
            onst result1 = FormToAuth(json);

            //只保留特定字段
            const result2 = FormToAuth(json, {
              keepFields: ['Details', 'Imgs', 'ValutId']
            });

            //保留特定字段并指定嵌套字段
            const result3 = FormToAuth(json, {
              keepFields: ['ReturnConsigneeAddress', 'Details'],
              keepNestedFields: {
                ReturnConsigneeAddress: ['Address', 'Contacts']
              },
              keepArrayItemFields: {
                Details: ['ProfessionalGrader', 'CertificationNumber'],
                Imgs: [] // 空数组表示保留所有数组元素
              }
            });

            //不保留任何字段（返回空）
            const result4 = FormToAuth(json, {
              keepFields: []
            });

            //保留所有字段但筛选嵌套字段
            const result5 = FormToAuth(json, {
              keepNestedFields: {
                ReturnConsigneeAddress: ['Address', 'Contacts']
              }
            });
        */

        // 配置选项
        const {
            // 要保留的顶级字段
            keepFields = [],
            // 嵌套对象中要保留的字段配置
            keepNestedFields = {},
            // 数组中嵌套对象要保留的字段配置
            keepArrayItemFields = {}
        } = options;

        // 1. 处理嵌套对象（排序）
        const processNestedObject = (obj, fieldNames) => {
            if (!obj || typeof obj !== 'object') return obj;

            const result = {};
            const filteredFields = fieldNames
                ? Object.entries(obj).filter(([key]) => fieldNames.includes(key))
                : Object.entries(obj);

            // 按首字母排序
            filteredFields
                .sort((a, b) => a[0].localeCompare(b[0]))
                .forEach(([key, value]) => {
                    result[key] = value;
                });

            return result;
        };


        // 2. 处理数组中的对象（过滤并排序）
        const processArray = (arr, fieldNames) => {
            if (!Array.isArray(arr)) return arr;

            return arr.map(item => {
                if (typeof item === 'object' && item !== null) {
                    const processedObj = processNestedObject(item, fieldNames);
                    // 如果处理后是空对象，则返回null，后续过滤掉
                    return Object.keys(processedObj).length > 0 ? processedObj : null;
                }
                return item;
            }).filter(item => item !== null); // 过滤掉空对象
        };

        // 3. 主处理逻辑
        const filteredForm = {};
        for (const [key, value] of Object.entries(form)) {
            // 处理空值
            if (value === '' || value === null || value === undefined) {
                continue;
            }

            // 检查是否需要保留此字段
            const shouldKeep = keepFields.length === 0 || keepFields.includes(key);
            if (!shouldKeep) {
                continue;
            }

            // 处理数组中嵌套对象
            if (Array.isArray(value) && keepArrayItemFields[key]) {
                const processedArray = processArray(value, keepArrayItemFields[key]);
                if (processedArray.length > 0) {
                    filteredForm[key] = processedArray;
                }
            }
            // 处理指定要保留的嵌套对象
            else if (keepNestedFields[key] && typeof value === 'object' && !Array.isArray(value)) {
                const processedObj = processNestedObject(value, keepNestedFields[key]);
                if (Object.keys(processedObj).length > 0) {
                    filteredForm[key] = processedObj;
                }
            }
            // 处理数组类型（不指定字段过滤）
            else if (Array.isArray(value)) {
                filteredForm[key] = value;
            }
            // 处理其他对象类型
            else if (typeof value === 'object' && value !== null) {
                // 对普通对象也进行排序
                const sortedObj = {};
                Object.keys(value)
                    .sort((a, b) => a.localeCompare(b))
                    .forEach(k => {
                        sortedObj[k] = value[k];
                    });
                filteredForm[key] = sortedObj;
            }
            // 保留其他基本类型
            else {
                filteredForm[key] = value;
            }
        }

        // 4. 按首字母排序
        const sortedKeys = Object.keys(filteredForm).sort((a, b) => a.localeCompare(b));
        const newForm = {};
        sortedKeys.forEach(key => {
            newForm[key] = filteredForm[key];
        });

        // 5. 构建参数字符串
        const params = sortedKeys
            .map(key => {
                const value = newForm[key];
                let encodedValue;

                if (typeof value === 'object') {
                    // 对象和数组都转为JSON字符串
                    encodedValue = JSON.stringify(value);
                } else {
                    encodedValue = value;
                }

                //return `${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
                return `${key}=${encodedValue}`;
            })
            .join('&');

        return {
            auth: md5(params + '&85125d62f592750977abaed12eca5898'),//
            data: newForm,
            params: params,
        };
    },
    firstLetterToUpper(obj, deep = false) {
        /**
         * 将 JSON 对象一级字段的首字母转为大写
         * @param {Object} obj - 输入的 JSON 对象
         * @param {boolean} [deep=false] - 是否递归处理嵌套对象
         * @returns {Object} 处理后的新对象
        */
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        const result = Array.isArray(obj) ? [] : {};
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                // 处理键名：首字母大写
                const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                // 处理值
                let value = obj[key];
                // 如果 deep 为 true 且值是对象/数组，递归处理
                if (deep && value && typeof value === 'object') {
                    value = firstLetterToUpper(value, deep);
                }

                result[capitalizedKey] = value;
            }
        }
        return result;
    },
    getUrlParams: function () {
        //URL参数转JSON
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        return params;
    },
    // 乘法
    numMulti: function (num1, num2) {
        var baseNum = 0;
        if (num1.toString().split(".")[1]) {
            baseNum += num1.toString().split(".")[1].length;
        }
        if (num2.toString().split(".")[1]) {
            baseNum += num2.toString().split(".")[1].length;
        }

        return (
            (Number(num1.toString().replace(".", "")) *
                Number(num2.toString().replace(".", ""))) /
            Math.pow(10, baseNum)
        );
    },
    //除法
    numDivision: function (num1, num2) {
        var baseNum1 = 0, baseNum2 = 0;
    
    if (num1.toString().split(".")[1]) {
        baseNum1 = num1.toString().split(".")[1].length;
    }
    if (num2.toString().split(".")[1]) {
        baseNum2 = num2.toString().split(".")[1].length;
    }
    
    // 除法：小数位数相减（num1的位数 - num2的位数）
    var baseNum = baseNum1 - baseNum2;
    
    return (
        (Number(num1.toString().replace(".", "")) /
            Number(num2.toString().replace(".", ""))) *
        Math.pow(10, -baseNum)  // 或者用 / Math.pow(10, baseNum)
    );
    },
    //加法
    numAdd(num1, num2) {
        var baseNum = 0
        if (num1.toString().split(".")[1]) {
            baseNum += num1.toString().split(".")[1].length;
        }
        if (num2.toString().split(".")[1]) {
            baseNum += num2.toString().split(".")[1].length;
        }
        return ((this.numMulti(num1, baseNum) + this.numMulti(num2, baseNum)) / baseNum).toFixed(baseNum >= 2 ? 2 : baseNum);
    },
    // 减法
    numSub(num1, num2) {
        var baseNum = 0

        if (num1.toString().split(".")[1]) {
            baseNum += num1.toString().split(".")[1].length;
        }
        if (num2.toString().split(".")[1]) {
            baseNum += num2.toString().split(".")[1].length;
        }
        return (
            (this.numMulti(num1, baseNum) - this.numMulti(num2, baseNum)) /
            baseNum
        ).toFixed(baseNum >= 2 ? 2 : baseNum);
    },
    //千分位
    thousandAndDecimal: function (num, fixed = 2) {
        var val = "";
        if (num) {
            val = parseFloat(num).toFixed(fixed).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        } else {
            val = num;
        }
        return val
    },

}
export default commonEventJs;


// WEBPACK FOOTER //
// ./src/common/CommonEventJs.js